export default __webpack_public_path__ + "static/media/Ballroll_00141.af0bac87.png";